$(function () {
    initNav();
    initSlick();
    initAanbodCarousel();
    initReviewSlider();
    initBlockSliderCarousel();

    // initUspsC/arousel();
    initDropdown();
    initMatchHeight();
    initObject();
    initScroll();
    initContact();
    initFaq();
    initFakeInput();
    // navshow();
    showMoreInfo();
    initReadMoreDetails();


    if ($('#mobile-object-photos').length > 0) {
        $('#mobile-object-photos').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });
    }


    // Cookie tijdelijk uit
    // if (getCookie('hide-pop-up') != 'yes') {
    //     DatHuis.pop('boer-gouda.nl', {
    //         position: 'bottomRight',
    //         backgroundColor: '#DD0332',
    //         textColor: '#ffffff',
    //         headerText: 'WAT IS MIJN HUIS WAARD?',
    //         subtext: 'Bereken eenvoudig de geschatte waarde van uw huis!', buttonText: 'Bereken',
    //         mobile: {
    //             subTextHidden: true
    //         },
    //         maxWidth: '320px',
    //         headerTextSize: '19px',
    //         subTextSize: '14px',
    //         buttonTextSize: '16px',
    //     });
    //
    //     $('#dathuis_waardeschatting_close_button').click(function () {
    //         writeCookie('hide-pop-up', 'yes', 1);
    //     });
    // }

});

function initReadMoreDetails() {
    const detailsContent = document.getElementById('details-content');
    const toggleBtn = document.getElementById('toggle-details');

    toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        detailsContent.classList.toggle('open');
        toggleBtn.classList.toggle('open');

        if (detailsContent.classList.contains('open')) {
            toggleBtn.classList.toggle('d-none');
        } else {
            toggleBtn.innerHTML = '<span class="circleplus"><i class="icon-plus"></i></span> Lees meer';
        }
    });
}

function navshow () {
    $('body').flurry({
        character: "❄",
        color: "white",
        speed: 6000,
        height: 980,
        frequency: 60,
        small: 12,
        large: 50,
        rotation: 90,
        rotationVariance: 20,
        startRotation: 90,
        wind: 10,
        windVariance: 100,
        opacityEasing: "cubic-bezier(1,0,.96,.9)"
    });
}

function showMoreInfo(){
    if ($('#showMoreInfo').length > 0) {
        $('#showMoreInfo').on('click', function () {
            $('.more-info-block').slideToggle('fast');
        });
    }
}

function writeCookie (key, value, days) {
    var date = new Date();

    // Default at 365 days.
    days = days || 365;

    // Get unix milliseconds at current time plus number of days
    date.setTime(+ date + (days * 86400000)); //24 * 60 * 60 * 1000

    document.cookie = key + "=" + value + "; expires=" + date.toGMTString() + "; path=/";

    return value;
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}

// $(window).on('load', function() {
//     orientObjectSlider();
// });

$(window).resize(function () {
    clearTimeout($.data(this, 'resizeTimer'));
    $.data(this, 'resizeTimer', setTimeout(function () {
        $nav.children('ul').attr('style', false);
        initObject();
        // orientObjectSlider();
    }, 200));
});

function initNav() {
    var $btn_navigation = $('header .nav-toggle');
    var $nav = $('header nav');

    $btn_navigation.click(function (e) {
        e.stopPropagation();
        e.preventDefault();

        if ($(window).width() < 980) {
            if ($nav.css('visibility') === 'hidden' || $nav.is(':hidden')) {
                $nav.slideDown();
                $('body').addClass('nav-open');
            } else {
                $nav.slideUp();
                $('body').removeClass('nav-open');
            }
        }
    });

    if ($nav.find('ul').length > 0) {
        var $li = $nav.find('li');

        $li.has('ul').children('a').click(function (e) {

            $(this).closest('ul').children('li').find('ul').each(function (i, ul) {
                if ($(ul) != $(this).next('ul')) {
                    $(this).prev('a').children('span').removeClass('toggle');

                    if ($(window).width() < 1024) {
                        $(ul).slideUp();
                    }
                }
            });

            if ($(this).next('ul').css('visibility') === 'hidden' || $(this).next('ul').is(':hidden')) {
                e.preventDefault();

                if ($(window).width() < 1024) {
                    $(this).next('ul').slideDown();
                }
                $(this).children('span').addClass('toggle');
            }
        });
    }
    //
    // $(window).scroll(function () {
    //     if ($(this).scrollTop() > 30) {
    //         $('.nav_wrapper').addClass('fixed');
    //     } else {
    //         $('.nav_wrapper').removeClass('fixed');
    //     }
    // });
}

function initBlockSliderCarousel() {
    if ($('#block-slider').length > 0) {
        $('#block-slider').slick({
            arrows: false,
            slidesToShow: 3,
            autoplay: true,
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
}

function initSlick() {
    // if ($('#header_carousel').length > 0) {
    //     $('#header_carousel').slick({
    //         dots: false,
    //         arrows: false,
    //         autoplay: true,
    //         autoplaySpeed: 6000,
    //         speed: 1500,
    //         slide: '.desktop',
    //         cssEase: 'ease-out',
    //         pauseOnHover: false,
    //         responsive: [
    //             {
    //                 breakpoint: 768,
    //                 settings: {
    //                     slide: '.mobile'
    //                 }
    //             }
    //         ]
    //     });
    // }


}

function initAanbodCarousel() {
    if ($('#aanbod_carousel').length > 0) {
        $('#aanbod_carousel').slick({
            arrows: true,
            slidesToShow: 3,
            prevArrow: $('#aanbod_wrapper .icon-chevron-left'),
            nextArrow: $('#aanbod_wrapper .icon-chevron-right'),
            responsive: [
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }
}

function initReviewSlider() {
    if ($('#reviewSlider').length > 0) {
        $('#reviewSlider').slick({
            slide: '.review',
            appendDots: $('#reviewSlider .nav'),
            arrows: false,
            dots: true,
            slidesToShow: 1
        });
    }
}

// function initUspsCarousel() {
//     if ($('#usps').length > 0) {
//         $('#usps').slick({
//             arrows: false,
//             slidesToShow: 3,
//             responsive: [
//                 {
//                     breakpoint: 768,
//                     settings: {
//                         slidesToShow: 1
//                     }
//                 }
//             ]
//         });
//     }
// }

function initDropdown() {
    $('.dropdown').each(function (i, el) {
        $(el).on('click', function () {
            $(el).find('ul').fadeToggle(150);

            $(el).find('a').on('click', function (e) {
                $(el).find('.value').text($(this).text());
            });
        });
    });
}

function initMatchHeight() {
    if ($('.matchheight').length > 0) {
        $('.matchheight').matchHeight();
    }
}

function initObject() {
    if ($('#object').length > 0) {
        // Button
        $('#omschrijving + a').on('click', function (e) {
            e.preventDefault();

            $('#omschrijving').addClass('show');
            $(this).hide();
        });

        // Lightbox
        if ($('.lightbox').length > 0) {
            $('.lightbox').magnificPopup({
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        }

        // initObjectPano();

        // Gallery icon
        $('.icon-zoom-in').on('click', function (e) {
            e.preventDefault();
            $('.lightbox').first().click();
        });
    }
}

function initObjectPano() {
    $('[id^=pano-]').each(function (index) {
        id = $(this).attr('data-id');
        data = {
            js: '/js/pano/pano.js',
            swf: '/js/pano/pano.swf',
            // xml: window.location.origin + window.location.pathname + '/pano/' + id + '.xml',
            target: 'pano-' + id,
            html5: 'prefer',
            passQueryParameters: true
        };
        embedpano(data);
    });
}

function initScroll() {
    if ($('.icon-scroll').length) {
        $('.icon-scroll').on('click', function (e) {
            e.preventDefault();
            $('html,body').stop().animate({
                scrollTop: $("#homepage").offset().top - 70
            }, 300, 'linear');
        });
    }
}

function initContact() {
    if ($('#contact').length > 0) {
        var latlng = new google.maps.LatLng($('#maps').data('lat'), $('#maps').data('lng'));

        map = new google.maps.Map(document.getElementById("maps"), {
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: latlng,
            scrollwheel: false
        });

        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            icon: '/img/icon-map.png'
        });
    }
}


function initFaq() {
    if ($('#faq').length > 0) {
        if ($('.faq_wrapper h3').length > 0) {

            $('.faq_wrapper h3').on('click', function (e) {
                if ($(this).next('ul').is(':visible')) {
                    $(this).next('ul').hide();
                } else {
                    $('.questions').hide();
                    $(this).next('ul').show();

                    $('html, body').animate({
                        scrollTop: $(this).offset().top - 100
                    }, 1000);
                }
            });
        } else {
            $('.questions').show();
        }

        $('.question').on('click', function () {
            $(this).siblings().removeClass('show');
            $(this).toggleClass('show');
        });
    }
}

function initFakeInput() {
    if ($('.fake_input')) {
        $('.fake_input').each(function (i, el) {
            var input = $(el).find('input[type=hidden]');
            var content = $(el).find('.content');

            $(el).on('click', function () {
                var ul = $(this).next();
                ul.fadeToggle(100);

                ul.find('li').on('click', function () {
                    input.val($(this).data('value'));
                    content.html($(this).text());
                    ul.fadeOut(100);
                });
            });

            if ($(el).is(':visible')) {
                $(document).click(function(e) {
                    if ($(e.target).closest(el).length === 0) {
                        $(el).next().fadeOut(100);
                    }
                });
            }
        });
    }
}